import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00765516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }

interface props {
    src: any,
    preview: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Images',
  props: {
    src: { default: '' },
    preview: { type: Boolean, default: true }
  },
  setup(__props: any) {

const define = __props;

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_image, {
      preview: _ctx.preview,
      src: _ctx.src,
      style: {"width":"100%"}
    }, null, 8, ["preview", "src"])
  ]))
}
}

})